import{e as o,g as i,m as r}from"./chunk-HBP5N4FR.js";var p={};i(p,{default:()=>t});import{persistStore as n}from"redux-persist";function t(e){return n(e)}var s=o(()=>{r()});export{t as a,p as b,s as c};
//# sourceMappingURL=chunk-6WZ7DVP7.js.map
